<template slot-scope="props">
  <section>
    <modal-card title="Edit Manager" style="margin: 0 auto;" contains-dropdown>
      <div class="columns">
        <div class="column is-half">
          <span class="mr-2">Level:</span>
          <b-select
            class="mr-4"
            v-model="form.type"
          >
            <option v-if="notification.user" value="mail">Mail</option>
            <option value="notification">Notification</option>
          </b-select>
        </div>
        <div class="column is-half">
          <div v-if="form.type === 'notification'">
            <span class="mr-2">Username:</span>
            <b-input :value="notification.device.model" readonly=""></b-input>
          </div>
          <div v-if="form.type==='mail'">
            <label>Email:</label>
            <b-input :value="notification.user.email" readonly=""></b-input>
          </div>
        </div>
      </div>
      <b-field horizontal v-if="form.type==='mail'" label="Subject">
        <b-input v-model="form.subject" size="sm"></b-input>
      </b-field>
      <b-field horizontal v-if="form.type==='mail'" label="Message">
        <b-input v-if="form.type ==='mail'" v-model="form.message" type="textarea" minlength="1" maxlength="1000" placeholder="">
        </b-input>
      </b-field>

        <b-field horizontal v-if="form.type==='notification'" label="Title">
          <b-input v-model="form.title" size="sm"></b-input>
        </b-field>
        <b-field horizontal v-if="form.type==='notification'" label="SubTitle">
          <b-input v-model="form.subtitle" size="sm"></b-input>
        </b-field>
        <b-field horizontal v-if="form.type==='notification'" label="Body">
          <b-input v-model="form.body" size="sm"></b-input>
        </b-field>
        <b-field horizontal v-if="form.type==='notification'" label="Link">
          <b-input v-model="form.link" size="sm"></b-input>
        </b-field>

      <div slot="foot">
        <b-button @click="$emit('close')" type="button" class="button">Cancel</b-button>

        <b-button @click="clickMe" class="button is-primary"
                  :class="{ 'is-loading': form.processing }">Send
        </b-button>
      </div>
    </modal-card>
  </section>
</template>

<script>
export default {
  props: {
    notification: {
      type: Object,
      required: true
    },
  },

  data() {
    return {
      form: new window.Form({
        type: this.notification.user ? "mail" : "notification",
        message: null,
        title: '',
        subtitle: '',
        body: '',
        image_url: '',
        link: this.$store.state.config.app.dl + '://q?type=home',
        subject: null,
        to: this.notification.device.id,
        email : this.notification.user ? this.notification.user.email : ''
      })
    }
  },
  methods: {
    clickMe() {
       this.form.post('/admin/api/feedback/reply').then(this.replySent());
    },

    replySent() {
      this.$buefy.toast.open("Reply sent.");
      this.$parent.close();
    }
  },
}
</script>
